// React
import React from "react";
import * as appRouting from "appRouting";
// Components
import CardPanel from "common/ui/components/nav/cardPanel/CardPanel";
import Card from "common/ui/components/nav/cardPanel/Card";
// Helpers
import NamingHelper from "common/utils/namingHelper";
const ProductOptions = ({ officeId }) => {
    return (React.createElement(CardPanel, { title: NamingHelper.products, titleColour: "#865977" },
        React.createElement(Card, { url: appRouting.productsFeaturedListingsUrl(officeId), label: NamingHelper.productsFeaturedListings, description: "Manage or purchase your featured listings here." }),
        React.createElement(Card, { url: appRouting.productsSpotlightListingsUrl(officeId), label: NamingHelper.productsSpotlightListings, description: "Manage or purchase your spotlight listings." }),
        React.createElement(Card, { url: appRouting.productsFeaturedAgentsUrl(officeId), label: NamingHelper.productsFeaturedAgents, description: "Manage your featured agents here." }),
        React.createElement(Card, { url: appRouting.productsOrderHdListingsUrl(officeId), label: NamingHelper.productsOrderHd, description: "Order an HD product for your listings here." })));
};
export default ProductOptions;
